
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/downloads/[slug]",
      function () {
        return require("private-next-pages/downloads/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/downloads/[slug]"])
      });
    }
  